
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPosTouchPanelTypeGrid extends Serenity.EntityGrid<PsPosTouchPanelTypeRow, any> {
        protected getColumnsKey() { return PsPosTouchPanelTypeColumns.columnsKey; }
        protected getDialogType() { return PsPosTouchPanelTypeDialog; }
        protected getIdProperty() { return PsPosTouchPanelTypeRow.idProperty; }
        protected getInsertPermission() { return PsPosTouchPanelTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosTouchPanelTypeRow.localTextPrefix; }
        protected getService() { return PsPosTouchPanelTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}